<template>
    <div class="content" v-loading="loading">
        <el-row :gutter="20">
            <el-col :span="17">
                <p v-show="isShow">{{cljy}}</p>
                <el-form ref="form" :model="form" class="flxz">
                    <el-col :span="23">
                    <el-form-item label="本机关认为">
                      <el-input type="textarea" :rows="16" placeholder="" v-model="form.content" :style="{width:'100%'}" @input="renew($event)"></el-input>
                    </el-form-item>
                    </el-col>
                    <el-col :span="23">
                    <p style="padding-bottom:20px;">温馨提示：说理内容最后部分表述格式如下：“......进行裁量，拟决定给予......的行政处罚”。</p>
                    </el-col>
                    <el-col :span="23">
                    <el-form-item size="large" label-width="0" style="text-align:center;">
                        <el-button type="primary" @click="submit">确定</el-button>
                        <el-button type="danger" @click="cancel">取消</el-button>
                    </el-form-item>
                    </el-col>
                </el-form>
            </el-col>
            <el-col :span="7">
              <ul class="zfmb">
                <li v-for="(item,index) in zfmbList" :key="index">
                  <p>
                    <el-checkbox :value="item.checked" @change="getActive(index)">{{item.mcjianxie}}</el-checkbox>
                  </p>
                </li>
              </ul>
              <div class="yanshangjiyao" style="margin-top:20px;">
                  <div class="select_list">
                      <el-select v-model="ysjy_year" size="small" style="width: 100px;">
                          <el-option value="2022">2022年</el-option>
                          <el-option value="2023">2023年</el-option>
                      </el-select>&nbsp;
                      <el-select v-model="ysjy_leibie" size="small" style="width: 120px;">
                          <el-option value="类别">类别</el-option>
                          <el-option value="职业卫生">职业卫生</el-option>
                          <el-option value="放射卫生">放射卫生</el-option>
                          <el-option value="医疗卫生">医疗卫生</el-option>
                          <el-option value="传染病">传染病</el-option>
                          <el-option value="学校卫生">学校卫生</el-option>
                          <el-option value="爱国卫生">爱国卫生</el-option>
                      </el-select>
                  </div>
                  <ul class="ysjy_file_list" style="width: 100%;">
                      
                  </ul>
              </div>
            </el-col>
        </el-row>
        
    </div>
</template>

<script>
import axios from 'axios'
import qs from 'qs'
    export default {
      components: {},
      props: ['text','law','cfyj','cljy'],
      data() {
        return {
          loading:false,
          form:{
            content:'',
          },
          isActive:'-1',
          zfmbList:[],
          ysjy_year:'2022',
          ysjy_leibie:'类别',
          isShow:false,
          fl_nr:'',
          basis_nr:'',
          list:[],

        }
      },
      watch:{
        text(){
          this.isActive = '-1'
        },
        law(){
          this.zfmbList = []
        }
      },
      created() {
        if(this.text){
          this.$set(this.form,'content',this.text)
        }else{
          this.$set(this.form,'content','')
        }
        this.getList();
      },
      async mounted() {
      },
      methods: {
        async getList(){
          this.zfmbList = []
          this.loading = true
          if(this.law || this.cfyj){
            this.getFlv(this.law, 0)
            this.getFlv(this.cfyj, 1)
          }else{
            let data = await this.$axios.get(`${this.Global._baseUrl2}?act=getZfmbXX&leibie=${escape('合议记录上的说理内容')}`)
            console.log(data)
            if(data.data){
              let arr = data.data
              arr.forEach(item => {
                item.checked = false
              })
              let str =  '当事人的行为违反了的规定，依据，' + this.cljy
              let str2 =  '当事人的行为违反了的规定，依据，' + this.cljy
              
              arr.push({
                  isMore: 0,
                  mc: str,
                  mcjianxie: '简化说理',
                  checked:false,
              });
              arr.push({
                  isMore: 0,
                  mc: str2,
                  mcjianxie: '详细说理',
                  checked:false,
              });
              arr.push({
                  isMore: 0,
                  mc: this.cljy,
                  mcjianxie: '处理建议上的裁量标准',
                  checked:false,
              });
              arr.push({
                  isMore: 0,
                  mc: '当事人的行为系初次发生、危害后果轻微且经复查已改正，参照《关于在浙江省卫生健康监管领域推行初次轻微违法行为不予处罚的意见 》所列情形，建议对当事人不予行政处罚。',
                  mcjianxie: '轻微不予处理模板',
                  checked:false,
              });
              this.zfmbList = arr
            }
            this.loading = false
          }
        },
        async getFlv(item,val){ 
            this.list = []    
            if (item.substr(item.length - 1) == '、') {
                item = item.substr(0, item.length - 1)
            }
            if(item.indexOf('、')!='-1'){
                let str=''
                let itemArr=item.split('、')
                itemArr.forEach((itema, i) =>{
                  console.log(itema)
                    let start= itema.indexOf("《");
                    let end= itema.indexOf("》");
                    let name = itema.substr(start + 1, end - start - 1);
                    if(name==''){
                        for(var m=i;m>0;m--){
                            if(itemArr[i-m].indexOf("《")!=-1&&itemArr[i-m].indexOf("》")!=-1){
                                start= itemArr[i-m].indexOf("《");
                                end= itemArr[i-m].indexOf("》");
                                name = itemArr[i-m].substr(start + 1, end - start - 1);
                            }
                        }
                    }
                    let list = itema.split('第')
                    let tiao='',kuan='',xiang='';
                    list.map(function(itemb){
                        if (itemb.indexOf('条') != -1) {
                            tiao = '第' + itemb
                        }
                        if (itemb.indexOf('款') != -1) {
                            if (itemb.indexOf('（') != -1) {
                                kuan = itemb.match(/（(\S*)）/)[1]
                            } else {
                                kuan = itemb.match(/(\S*)款/)[1]
                            }
                        }
                        if (itemb.indexOf('项') != -1) {
                            if (itemb.indexOf('（') != -1) {
                                xiang = '（'+itemb.match(/（(\S*)）/)[1]+'）'
                            } else {
                                xiang = '（'+itemb.match(/(\S*)项/)[1]+'）'
                            }
                        }
                    })
                    console.log(name,tiao,kuan,xiang)
                    if (itema.indexOf('条') != -1) {
                      this.list.push({name:name,tiao:tiao,kuan:kuan,xiang:xiang})
                    }
                 })
            }else{
              let start= item.indexOf("《");
              let end= item.indexOf("》");
              let name = item.substr(start + 1, end - start - 1);
              let list = item.split('第')
              let tiao='',kuan='',xiang='';

              list.map(function(itemb){
                  if (itemb.indexOf('条') != -1) {
                      tiao = '第' + itemb
                  }
                  if (itemb.indexOf('款') != -1) {
                      if (itemb.indexOf('（') != -1) {
                          kuan = itemb.match(/（(\S*)）/)[1]
                      } else {
                          kuan = itemb.match(/(\S*)款/)[1]
                      }
                  }
                  if (itemb.indexOf('项') != -1) {
                      if (itemb.indexOf('（') != -1) {
                          xiang = '（'+itemb.match(/（(\S*)）/)[1]+'）'
                      } else {
                          xiang = '（'+itemb.match(/(\S*)项/)[1]+'）'
                      }
                  }
              })
              if (item.indexOf('条') != -1) {
                let data = await this.$axios.get(`${this.Global._baseUrl2}?act=getFalvTiaoXiang&falvName=${escape(name)}&tiao=${escape(tiao)}&kuan=${escape(kuan)}&xiang=${escape(xiang)}`)
                
                if(data.data){
                    if (data.data == '条传值错误') {
                        
                    }else{
                      console.log(data.data)
                      if(val==0){
                          this.fl_nr = item + '“' + data.data+ '”'
                      }else{
                          this.basis_nr = item + '“' + data.data+ '”'
                      }
                    }
                }
             }else{
                if (val == 0) {
                    this.fl_nr.push(item)
                } else {
                    this.basis_nr.push(item)
                }
             }
            }
            if(this.list){
              let arr = item.split('、')
              let arr2 = []
              for(var i=0;i<this.list.length;i++){
               let res = await this.$axios.get(`${this.Global._baseUrl2}?act=getFalvTiaoXiang&falvName=${escape(this.list[i].name)}&tiao=${escape(this.list[i].tiao)}&kuan=${escape(this.list[i].kuan)}&xiang=${escape(this.list[i].xiang)}`)
                 console.log(res) 
                if(res.data){
                    if (res.data == '条传值错误') {
                          
                    }else{
                      arr2.push( arr[i] + '“' + res.data+ '”')
                      console.log(arr2)
                      if(val==0){
                        this.fl_nr = arr2.join('和')
                      }else{
                        this.basis_nr = arr2.join('和')
                      }
                    }
                        console.log(this.fl_nr) 
                } else{
                      if(val==0){
                          this.fl_nr.push( itema)
                      }else{
                          this.basis_nr.push( itema)
                      }
                } 
              }  
              
            }
            console.log(this.fl_nr)
            console.log(this.basis_nr)
            setTimeout(()=>{
              this.getLabel()
            },5000)
          
        },
        async getLabel() {
          let gain_str='',gain_str2='';
          let data = await this.$axios.get(`${this.Global._baseUrl2}?act=getZfmbXX&leibie=${escape('合议记录上的说理内容')}`)
          console.log(data)
          if(data.data){
              let arr = data.data
              arr.forEach(item => {
                item.checked = false
              })
              this.zfmbList = arr
              var str, strDxyj, strClyj, txt;
              strDxyj = this.law;
              strClyj = this.cfyj;
              txt = this.cljy;

              console.log(this.cljy)
              var canzhaolength = this.cljy ? txt.split('参照').length : 0
              console.log(txt,canzhaolength)
              if (canzhaolength > 2 || canzhaolength == 1) {
                  var new_arr1 = strDxyj.split('、')
                  var new_arr4 = []
                  new_arr1.forEach(function (item, index) {
                      var new_arr3 = item.split('》')
                      new_arr3.forEach(function (item1, index1) {
                          if (item1.indexOf('《') != -1) {
                              item1 = item1 + '》'
                          }
                          new_arr4.push(item1)
                      })

                  })
                  var law_mb = ''
                  var last_law = []
                  new_arr4.forEach(function (item4, index4) {
                      if (item4.indexOf('《') != -1) {
                          law_mb = item4
                      } else {
                          last_law.push(law_mb + item4)
                      }
                  })
                  console.log(last_law)

                  var new_arr2 = strClyj.split('、')
                  var new_arr6 = []
                  new_arr2.forEach(function (item2, index2) {
                      var new_arr5 = item2.split('》')
                      new_arr5.forEach(function (item5, index5) {
                          if (item5.indexOf('《') != -1) {
                              item5 = item5 + '》'
                          }
                          new_arr6.push(item5)
                      })

                  })
                  var basis_mb = ''
                  var last_basis = []
                  new_arr6.forEach(function (item6, index6) {
                      if (item6.indexOf('《') != -1) {
                          law_mb = item6
                      } else {
                          last_basis.push(law_mb + item6)
                      }
                  })
                  console.log(last_basis)

                  var last_txt = ''
                  var last_txt2 = ''                              
                  last_law.forEach(function (item_l, index_l) {
                      last_txt += '当事人的行为违反了' + item_l + '的规定，'
                      last_txt2 += '当事人的行为违反了' + item_l + '的规定，'
                      if (last_basis[index_l]) {
                          last_txt += '依据' + last_basis[index_l] + '，'
                          last_txt2 += '依据' + last_basis[index_l] + '，' + txt
                      }
                  })
                  if (canzhaolength == 1) {
                      str = last_txt2
                  } else {
                      str = last_txt + txt;
                  }                                
              } else {
                  str = '当事人的行为违反了' + strDxyj + '的规定，依据' + strClyj + '，' + txt;
              }
              console.log(this.fl_nr)
              console.log(this.basis_nr)
              
              // if(this.law.indexOf('、')!='-1'){
              //   var strDxyj2 = this.fl_nr.join('和')
              //   var strClyj2 = this.basis_nr.join('和')
              //   console.log(strDxyj2)
              //   console.log(strClyj2)
                

              //   var last_txt_nr= ''
              //   this.fl_nr.forEach(function (item_2, index_2) {
              //       last_txt_nr += '当事人的行为违反了' + item_2 + '的规定，'
              //       if (basis_nr[index_2]) {
              //           last_txt_nr += '依据' + basis_nr[index_2] + '，' + txt
              //       }
              //   })
              //   // if (canzhaolength == 1) {
              //     str2 = last_txt_nr
              // // }
              // }else{
              var str2 = '当事人的行为违反了' + this.fl_nr + '的规定，依据' + this.basis_nr + '，' + txt;
              // }
              
              

              gain_str = str;
              gain_str2 = str2
              this.zfmbList.push({
                  isMore: 0,
                  mc: str,
                  mcjianxie: '简化说理',
                  checked:false
              });
              this.zfmbList.push({
                  isMore: 0,
                  mc: str2,
                  mcjianxie: '详细说理',
                  checked:false
              });
              this.zfmbList.push({
                  isMore: 0,
                  mc: this.cljy,
                  mcjianxie: '处理建议上的裁量标准',
                  checked:false
              });
              this.zfmbList.push({
                  isMore: 0,
                  mc: '当事人的行为系初次发生、危害后果轻微且经复查已改正，参照《关于在浙江省卫生健康监管领域推行初次轻微违法行为不予处罚的意见 》所列情形，建议对当事人不予行政处罚。',
                  mcjianxie: '轻微不予处理模板',
              });
              this.loading = false
          }
        },
        renew(e){
          this.$forceUpdate()
        },
        submit(){
          this.$emit("handleBackShuoli",this.form.content)
        },
        cancel(){
          this.$emit("shuoliTk",false)
        },

        getActive(index){
          console.log(index)
          
          this.$set(this.zfmbList[index],'checked',!this.zfmbList[index].checked)
          this.$forceUpdate()
          if(index == 4){ 
            this.isShow = true 
          }else{
            if(this.zfmbList[index].checked){
              this.getXunwennr(this.zfmbList[index])
            }
          }
        },
        getXunwennr(item){
          console.log(this.form.content)
          if(this.form.content && this.form.content.indexOf(item.mc) != -1){
            this.$message.error('不能重复添加')
          }else{
            this.form.content = this.form.content ? this.form.content + item.mc : item.mc
          }
        },
      }
    }
</script>

<style scoped>
.content{position: relative;}
.zfmb{ border:1px solid #DCDFE6; padding: 20px;max-height: 500px; overflow-y: auto;}
.zfmb li{line-height: 40px;}
.zfmb li p i{ width: 22px; height: 20px;float: left;; margin:10px 7px 0 0;}
.zfmb li p b{ cursor: pointer;}
.icon1{ background: url(../../../assets/images/wjjm.png);}
.icon2{ background: url(../../../assets/images/wjjm-a.png);}
.zfmb2{width: 100%;}
.zfmb2 span{ cursor: pointer; display: block; padding-left: 30px; background: url(../../../assets/images/wjj.png) no-repeat center left; margin-left: 30px;}
.zfmb2 span.dqSpan{color:#0C80E8;}
.zfmb2 span b{ display: none; position: absolute; top:40px;left: 120px; width: 600px; font-weight: normal; background:#303133; color: #fff;padding: 5px 10px;
    border-radius: 6px;}
.zfmb2 span:hover b{ display: block;}
.el-form >>> .el-textarea.is-disabled .el-textarea__inner { color: #333 !important;}
</style>
